import { Utils } from './../../../../core/utils';
import { AuthenticationService } from './../../../../commons/servicos/authentication.service';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { SessionAnuglarService } from '../../../../core/session-anuglar.service';
import { UserUtil } from './../../../../core/user-util';
import { LoginService } from '../../../../commons/servicos/login.service';
import { ConfirmationService } from 'primeng/primeng';
import { WebsocketService } from '../../../../core/websocket-service.service';
import { environment } from '../../../../../environments/environment';
import { Subscription } from 'rxjs/Rx';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
  showIcones = false;
  showMenu = false;
  username: string;
  unidadeSelecionada = UserUtil.usuarioLogado &&  UserUtil.usuarioLogado.unidPolicial ? UserUtil.usuarioLogado.unidPolicial.descricao: '';
  dtLogin: Date = this.userUtil.sysdateUser;
  versao;
  displayConfirmaSair: Boolean = false;
  displayConfirmaOffline: Boolean = false;
  displayDesconectado: Boolean = false;
  FL_QUADRO_AVISO = false;
  stompClient;
  serverUrl = environment.websocketURL;

  medicoEmmiter = false;
  telaMedicoSub: Subscription;
  limitInstaceSub: Subscription;

  googleMapsScriptIsInjected = false;

  static _statusServer;
  _janeiro;
  openBh = false;
  ignoreReconnect = false;
  isUnimdeBH = environment.isUnimedBH;
  clienteId = environment.pathImagens;
  static i = 0;

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private loginService: LoginService,
    private userUtil: UserUtil,
    private confirmService: ConfirmationService,
    private ws: WebsocketService) {
      HomeComponent.i++;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
      }
      // NavigationEnd
      // NavigationCancel
      // NavigationError
      // RoutesRecognized
    });
   }

  initializeWebSocketConnection() {
  //  console.log(window.document.location);
  }

  injectGoogleMapsApiScript = (options = {}) => {
    if (this.googleMapsScriptIsInjected) {
      throw new Error('Google Maps Api is already loaded.');
    }

    const optionsQuery = Object.keys(options)
      .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(options[k])}`)
      .join('&');

    const url = `https://maps.googleapis.com/maps/api/js?${optionsQuery}`;

    const script = document.createElement('script');

    script.setAttribute('src', url);
    script.setAttribute('async', '');
    script.setAttribute('defer', '');

    document.head.appendChild(script);

    this.googleMapsScriptIsInjected = true;
  }

  contahome = 0;
  self;
  ngOnInit() {
    var self = this;
    this.ignoreReconnect = false;
    this.injectGoogleMapsApiScript( {key: environment.googleapi,
      region: 'BR',
      language: 'pt-BR',
      v: '3.45',
      libraries: 'places'
    });
    this.username = UserUtil.usuarioLogado.nome;
    this.dtLogin = UserUtil.usuarioLogado.logadoEm;
    this.versao = UserUtil.usuarioLogado.versao;
    HomeComponent._statusServer = this.ws.status;
    // this.FL_QUADRO_AVISO = UserUtil.parametrosList['FL_QUADRO_AVISO'] === 'S';
    this.FL_QUADRO_AVISO = true;

    this.limitInstaceSub = SessionAnuglarService.limitInstace.subscribe(res => {
      SessionAnuglarService.logout();
      this.displayDesconectado = true;
    });

    this.telaMedicoSub = this.loginService.sequencia.subscribe(resposta => {
      if (this.displayConfirmaSair) {
        this.realizarLogout();
      }
    });

    SessionAnuglarService.accessHome();

    if (!this.ws.status) {
      if(SessionAnuglarService.getAccess() > 1) {
        this.displayConfirmaOffline = true;
      } else {
        this.ws.connect(UserUtil.usuarioLogado.login);
      }
    }
    this.ws.mudaStatusServer.subscribe(res => {
      HomeComponent._statusServer = res;
    });
    this.ws.closeEvent.subscribe(res => {
      if(this.ignoreReconnect) {
        return;
      }
      //SessionAnuglarService.logout();
      console.log('Desconectado do Websocket...');
      setTimeout(ticks => {
        console.log('Reconectando ...');
        this.ws.connect(UserUtil.usuarioLogado.login);
      }
      , 1000);
    });
  }

  ngOnDestroy(): void {
    if(this.telaMedicoSub) {
      this.telaMedicoSub.unsubscribe();
    }
    if (this.limitInstaceSub) {
      this.limitInstaceSub.unsubscribe();
    }
    if (this.ws) {
      this.ignoreReconnect = true;
      this.ws.close();
    }
  }

  efetuarLogout(url: string) {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.token ) {
      const token = currentUser.token;
      /* Se nao estiver na tela do Medico Regulador realiza o logout aqui mesmo,
         caso contrario, realiza o logout no canDeactivate */
      if (url.indexOf('CAD0140') < 0) {
        UserUtil.cliqueSair = false;
        this.authenticationService.registrarlogout(token).subscribe(resposta => {});
      }
    } else {
      SessionAnuglarService.logout();
    }
  }

  get statusServer(){
    return HomeComponent._statusServer;
  }

  clicaIcone() {
    this.showMenu = false;
  }

  logoutAction() {
    /*if (!SessionAnuglarService.verificaTelaMedico()) {*/
       this.displayConfirmaSair = true;
     /*} else {
       this.confirmService.confirm({
           header: 'Atenção!',
           message: 'Necessário sair da tela do Médico Regulador.',
           acceptLabel: 'OK',
           rejectVisible: false
         }
       );
     }*/
    }

  redirectHome() {
    this.router.navigate(['/home/welcome'], { skipLocationChange: true });
  }

  realizarLogout() {
    this.ws.close();
    this.ignoreReconnect = true;
    UserUtil.cliqueSair = true;
    this.displayConfirmaSair = false;
    this.efetuarLogout(this.router.url);
    this.router.navigate(['/login'], { skipLocationChange: true });
    this.medicoEmmiter = false;
  }

  logoutActionConfirme() {
    if (!SessionAnuglarService.verificaTelaMedico()) {
      this.realizarLogout();
    } else {
      this.medicoEmmiter = true;
      this.redirectHome();
    }

  }

  logoutCookie() {

    this.router.navigate(['/login'], { skipLocationChange: true });

  }

  getFormataData(dtLogin) {

    return Utils.formataDataTipe(new Date(dtLogin));

  }

  onActivate(event) {
    this.openBh = event.isAreaDeTrabalho;
  }

  onDeactivate(event){
  }

}



// WEBPACK FOOTER //
// ./src/app/modulos/principal/ui/home/home.component.ts